import * as React from 'react';
import * as Redux from 'redux';
import * as ReactRedux from 'react-redux';
import { ILDataSave } from './il-data-save';
import { IConfigState, IState, IUIState, IUploadState } from '../../../interfaces';

export interface IILDataSaveStateProps {
  readonly ui: IUIState;
  readonly upload: IUploadState;
  readonly config: IConfigState;
}

export type IILDataSaveConnectProps = IILDataSaveStateProps
  & ReactRedux.DispatchProp<Redux.Action>;

export function mapStateToProps(state: IState): IILDataSaveStateProps {
  return {
    ui: state.ui,
    upload: state.upload,
    config: state.config
  };
}

export const ILDataSaveContainer: React.ComponentClass
  = ReactRedux.connect(mapStateToProps)(ILDataSave);
